<template>
  <div class="flex flex-col">
    <div v-for="num in 5" :key="num" class="p-8">
      <RevSkeleton
        :class="{
          'md:hidden': num > 3,
        }"
        height="24px"
        shape="line"
        width="136px"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { RevSkeleton } from '@ds/components/Skeleton'
</script>
